import { MarketsDataGridField } from "~/feature/event/components/MarketsDataGrid/types";

type ColumnSizing = {
  minWidth: number;
  width?: number;
  flex?: number;
};

const MARKET_WIDTH = 220;
const PERCENTAGE_WIDTH = 160;
const PRICE_WIDTH = 195;
const SPREAD_WIDTH = 210;
const LIQUIDITY_WIDTH = 110;
const VOLUME_WIDTH = 110;
const H24_WIDTH = 80;
const D7_WIDTH = 80;
const OPEN_INTEREST_WIDTH = 140;
const ENDS_ID_WIDTH = 110;
const RESULT_WIDTH = 140;
const TRADE_WIDTH = 85;

const MARKET_FLEX = 14;
const PERCENTAGE_FLEX = 5;
const PRICE_FLEX = 6;
const SPREAD_FLEX = 6;
const LIQUIDITY_FLEX = 4;
const VOLUME_FLEX = 4;
const H24_FLEX = 2;
const D7_FLEX = 2;
const OPEN_INTEREST_FLEX = 3;
const ENDS_IN_FLEX = 4;

export const marketColumnSizing: Record<MarketsDataGridField, ColumnSizing> = {
  [MarketsDataGridField.Market]: {
    minWidth: MARKET_WIDTH,
    flex: MARKET_FLEX,
  },
  [MarketsDataGridField.Chance]: {
    minWidth: PERCENTAGE_WIDTH,
    flex: PERCENTAGE_FLEX,
  },
  [MarketsDataGridField.Price]: {
    minWidth: PRICE_WIDTH,
    flex: PRICE_FLEX,
  },
  [MarketsDataGridField.Spread]: {
    minWidth: SPREAD_WIDTH,
    flex: SPREAD_FLEX,
  },
  [MarketsDataGridField.Liquidity]: {
    minWidth: LIQUIDITY_WIDTH,
    flex: LIQUIDITY_FLEX,
  },
  [MarketsDataGridField.Volume]: {
    minWidth: VOLUME_WIDTH,
    flex: VOLUME_FLEX,
  },
  [MarketsDataGridField.H24]: {
    minWidth: H24_WIDTH,
    flex: H24_FLEX,
  },
  [MarketsDataGridField.D7]: {
    minWidth: D7_WIDTH,
    flex: D7_FLEX,
  },
  [MarketsDataGridField.OpenInterest]: {
    minWidth: OPEN_INTEREST_WIDTH,
    flex: OPEN_INTEREST_FLEX,
  },
  [MarketsDataGridField.EndsIn]: {
    minWidth: ENDS_ID_WIDTH,
    flex: ENDS_IN_FLEX,
  },
  [MarketsDataGridField.Status]: {
    minWidth: RESULT_WIDTH,
    flex: ENDS_IN_FLEX,
  },
  [MarketsDataGridField.Trade]: {
    minWidth: TRADE_WIDTH,
    width: TRADE_WIDTH,
  },
};

export const marketPinnedColumnsPadding: Record<string, number> = {
  [MarketsDataGridField.Market]: 0,
  [MarketsDataGridField.Trade]: MARKET_WIDTH,
};
